import { render, staticRenderFns } from "./change-history.vue?vue&type=template&id=a6298f1a&scoped=true"
import script from "./change-history.vue?vue&type=script&lang=js"
export * from "./change-history.vue?vue&type=script&lang=js"
import style0 from "./change-history.vue?vue&type=style&index=0&id=a6298f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6298f1a",
  null
  
)

export default component.exports